import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actions: {
      alignSelf: 'center',
      padding: theme.spacing(3, 1),
    },
  }),
);
export default useStyles;
